<div *ngIf="loading"
     class="loading-overlay">
    <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
    <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>

<div class="row animated fadeIn fast">
    <div class="col-12">
        <div class="card border rounded animated fadeIn fast">
            <!-- cabecera para sustitución de artículo desde campanyaNew.component -->
            <div class="card-body">
                <div class="alert alert-success alert-dismissible fade show border border-success"
                     *ngIf="articuloExterno.id"
                     style="border-width: 2px! important;">
                    <h4><strong>Selecciona el artículo a Sustituir por el que aparece en el pedido <span class="text-info">{{articuloExterno.pedido_cli}}</span> de {{parametrosUrl.cliNombre}}:</strong></h4>
                    <table class="table table-sm table-bordered tabla-borde-negro">
                        <tr>
                            <td><span class="badge badge-secondary me-1"><i class="fa fa-barcode"></i> Ean:</span> {{articuloExterno.ean}}</td>
                            <td><span class="badge badge-secondary me-1">SKU:</span> {{articuloExterno.sku}}</td>
                            <td><span class="badge badge-secondary me-1">Descripción:</span> {{articuloExterno.descripcion}}</td>
                            <td><span class="badge badge-secondary me-1">Cantidad en el pedido:</span> {{articuloExterno.cantidad | number:'1.0-0':'es'}}</td>
                            <td>
                                <div class="text-right">
                                    <button [disabled]="loading"
                                            type="button"
                                            [routerLink]="'/panel/campanya_new'"
                                            class="btn waves-effect waves-light btn-rounded btn-secondary">Cancelar cambio</button>
                                </div>
                            </td>
                        </tr>
                    </table>

                </div>
            </div>

            <div class="card-body">

                <!-- cabecera -->
                <div class="row mb-2">

                    <div class="col-6">
                        <div class="input-group border border-dark rounded">
                            <input class="form-control"
                                   type="text"
                                   id="buscaTodo"
                                   autofocus
                                   placeholder="Buscar cualquier dato..."
                                   [(ngModel)]="strBuscarTodo"
                                   (keyup)="buscarTodo($event)" />
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary"
                                        type="button"
                                        title="Limpiar búsqueda"
                                        (click)="limpiaBusca()">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="input-group border border-dark rounded">
                            <div class="input-group-addon"><i class="fa-solid fa-user"></i></div>
                            <select class="form-control"
                                    [disabled]="parametrosUrl.id_cliente"
                                    [(ngModel)]="cliSeleccionado"
                                    (ngModelChange)="onClienteSelect($event)">
                                <option value=''>Todos los clientes</option>
                                <option *ngFor="let cli of clientesList"
                                        [value]=cli.id>
                                    {{cli.nombre}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-3">
                        <form>

                            <div class="row float-right">
                                <div class="col-sm-6">
                                    <div class="form-group rounded">
                                        <select class="form-control"
                                                name="rowsLimitStr"
                                                [(ngModel)]="rowsLimitStr"
                                                (change)="rowsLimitChange()">
                                            <option [value]="10">10</option>
                                            <option [value]="50">50</option>
                                            <option [value]="100">100</option>
                                            <option [value]="999999">Todo</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group float-right">
                                        <div class="btn-group">
                                            <button type="button"
                                                    [routerLink]="'/panel/articulo_edit/new'"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Nuevo"
                                                    [disabled]="parametrosUrl.articuloExterno_id">
                                                <i class="fa-solid fa-plus"></i>
                                            </button>

                                            <button type="button"
                                                    (click)="getListaArtic()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Recargar datos">
                                                <i class="fa-solid fa-sync"></i>
                                            </button>

                                            <button type="button"
                                                    (click)="exportToExcel()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Descargar Excel">
                                                <i class="fa-solid fa-download"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </form>
                    </div>

                </div>



                <div class="rounded border">

                    <!-- datatable -->
                    <ngx-datatable class='bootstrap'
                                   [style.width]="'100%'"
                                   [columns]="columns"
                                   [columnMode]="'force'"
                                   [loadingIndicator]="loading"
                                   [headerHeight]="70"
                                   [footerHeight]="50"
                                   [rowHeight]="50"
                                   [limit]="rowsLimit"
                                   [rows]='rows'
                                   [messages]="messages">

                        <!-- id -->
                        <ngx-datatable-column name="id"
                                              [width]="60"
                                              [maxWidth]="80"
                                              [resizeable]="false">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <div class="header noSearch"
                                     (click)="sort()">
                                    <h6 class="title link">ID</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="Doble click para busqueda global"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- foto -->
                        <ngx-datatable-column name=''
                                              prop="foto"
                                              [width]="60"
                                              [maxWidth]="60"
                                              [resizeable]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-cell-template
                                         let-row="row"
                                         let-value="value">
                                <div *ngIf="value">
                                    <img [src]="fotoDir +'/articulos' + imgResized + value"
                                         loading="lazy"
                                         (click)="abrirModal(row)"
                                         alt="Foto"
                                         class="rounded pointer border"
                                         height="25px"
                                         title="Cambiar/borrar foto">
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- cliNombre -->
                        <ngx-datatable-column name="cliNombre"
                                              [width]="200"
                                              [minWidth]="150"
                                              [maxWidth]="250">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'cliNombre')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="title link">Cliente</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="Doble click para busqueda global"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- sku -->
                        <ngx-datatable-column name="sku"
                                              [width]="120"
                                              [minWidth]="100"
                                              [maxWidth]="150">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'sku')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="title link">SKU</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="Doble click para busqueda global">
                                    <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></span>
                                    <span *ngIf="row.swDefectuoso == Constantes.DEFECTUOSO"
                                          class="text-warning ml-12">
                                        <i title="Defectuoso"
                                           class="text-warning ml-1 fa-solid fa-triangle-exclamation"></i>
                                    </span>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- ean -->
                        <ngx-datatable-column name="ean"
                                              [width]="140"
                                              [minWidth]="120"
                                              [maxWidth]="180">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'ean')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="title link"><i class="fa fa-barcode"></i> Ean</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="Doble click para busqueda global"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- descripcion -->
                        <ngx-datatable-column name="descripcion"
                                              [width]="300"
                                              [minWidth]="200"
                                              [maxWidth]="500">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <input type="search"
                                       class="form-control form-control-sm"
                                       placeholder="Buscar..."
                                       (keyup)="buscar($event, 'descripcion')"><br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="title link">Descripción</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <span *ngIf="row.url">
                                    <a href="{{row.url}}"
                                       target="_blank"
                                       title="Abrir {{row.url}}">
                                        <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                                    </a>
                                </span>
                                <div *ngIf="!row.url"
                                     [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- stock -->
                        <ngx-datatable-column name="Stock"
                                              prop='artStock'
                                              [cellClass]="'text-right'"
                                              [width]="80"
                                              [minWidth]="70"
                                              [maxWidth]="100">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="title link mt-12"
                                        title="Stock disponible">Stock</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div (dblclick)="dblclickCampo(value)"
                                     title="Doble click para busqueda global">
                                    {{value | number: '0.0-0':'es'}}
                                    <small *ngIf="value && row.unidadesCaja > 0"
                                           title="{{row.unidadesCaja | number: '0.0-0':'es'}} Unidades por Caja"
                                           class="text-muted d-block"
                                           style="margin-top: -5px;">({{value / row.unidadesCaja | number: '0.0-0':'es'}} Cajas)</small>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- unidadesCaja -->
                        <ngx-datatable-column name="Unidades por caja"
                                              prop='unidadesCaja'
                                              [width]="80"
                                              [minWidth]="100"
                                              [maxWidth]="120">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="title link mt-12"
                                        title="Unidades por caja">Unid. x Caja</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <span *ngIf="value > 0">{{value | number: '0.0-0':'es'}} </span>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- volumen -->
                        <ngx-datatable-column name="Vol."
                                              prop='volumen'
                                              [width]="80"
                                              [minWidth]="70"
                                              [maxWidth]="100">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="title link mt-12"
                                        title="Volumen en m3">Vol.</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div *ngIf="value > 0">
                                    {{value | number: '0.3-3':'es'}} m3
                                </div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- volumen total -->
                        <ngx-datatable-column name="Vol. Total"
                                              prop='volumen'
                                              [width]="100"
                                              [minWidth]="80"
                                              [maxWidth]="120">
                            <ng-template ngx-datatable-header-template
                                         let-value="value"
                                         let-sort="sortFn"
                                         let-column="column">
                                <br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="title link mt-12"
                                        title="Volumen ocupado en almacén en m3">Vol. Total</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         let-row="row"
                                         ngx-datatable-cell-template>
                                <div *ngIf="row.volumen * row.artStock > 0">
                                    {{row.volumen * row.artStock | number: '0.3-3':'es'}} m3
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- swLote -->
                        <ngx-datatable-column name="Lotes"
                                              prop='swLote'
                                              [width]="60"
                                              [minWidth]="50"
                                              [maxWidth]="70">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="title link mt-12"
                                        title="Gestión de lotes">Lote</h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="value | iconCheck"></div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- swEntradasDirectas -->
                        <ngx-datatable-column prop='swEntradasDirectas'
                                              [width]="60"
                                              [minWidth]="50"
                                              [maxWidth]="70">
                            <ng-template ngx-datatable-header-template
                                         let-sort="sortFn"
                                         let-column="column">
                                <br>
                                <div class="header"
                                     (click)="sort()">
                                    <h6 class="title link mt-12"
                                        title="Permite entradas directas a Stock Pda"><i class="fa-solid fa-truck-ramp-box mr-2"></i> </h6>
                                </div>
                            </ng-template>
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="value | iconCheck"></div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- Acciones -->
                        <ngx-datatable-column [width]="80"
                                              [minWidth]="70"
                                              [maxWidth]="100"
                                              [sortable]="false">
                            <ng-template let-row="row"
                                         let-value="value"
                                         ngx-datatable-cell-template>

                                <!-- Opciones para seleccionar articulo -->
                                <span *ngIf="articuloExterno.id">
                                    <span *ngIf="articuloExterno.id_articulo != row.id">
                                        <a (click)="cambiaArticulo(row)"
                                           class="link mr-2 pointer"
                                           title="Seleccionar artículo">
                                            <span class="acciones-badge">S</span>
                                        </a>
                                    </span>
                                </span>

                                <!-- Opciones normales -->
                                <span *ngIf="!articuloExterno.id">
                                    <div ngbDropdown
                                         class="d-inline-block "
                                         container="body">
                                        <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                                data-toggle="dropdown"
                                                type="button"
                                                style="border-width: 1px;">
                                            <i class="fa-solid fa-ellipsis-vertical"></i>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-left">
                                            <a [routerLink]="['/panel/articulo_edit',row.id]"
                                               class="link mr-2 dropdown-item"
                                               placement="top"
                                               title="Editar artículo">
                                                <i class="fa-solid fa-pen-to-square"></i> Editar artículo
                                            </a>
                                            <a (click)="eanLabelsSrv.imprimirEanLabel(row.id)"
                                               class="link mr-2 dropdown-item"
                                               placement="top"
                                               title="Generar etiquetas EAN">
                                                <i class="fa-solid fa-barcode"></i> Generar etiquetas EAN
                                            </a>

                                            <hr style="margin: 0px;">

                                            <a (click)="row.artStock < 1 ? archivarClick(row) : null"
                                               class="link mr-2 dropdown-item text-danger"
                                               placement="top"
                                               ngbTooltip="Archivar artículo en el histórico"
                                               [class.disabled]="row.artStock >= 1"
                                               [attr.aria-disabled]="row.artStock >= 1 ? true : null"
                                               data-toggle="tooltip"
                                               title="Archivar artículo en el histórico">
                                                <i class="fa-regular fa-trash-can fa"></i> Archivar artículo
                                            </a>

                                        </div>
                                    </div>
                                </span>

                            </ng-template>
                        </ngx-datatable-column>

                    </ngx-datatable>

                </div>






                <!-- barra + botón carga más -->
                <div class="d-flex align-items-center mb-2"
                     *ngIf="articulosList.length < recTotal ">
                    <div class="d-flex align-items-center"
                         *ngIf="mostrarCargaMas">

                        <!-- Texto y barra en vertical -->
                        <div class="d-flex flex-column me-3">
                            <p class="mb-1">
                                <strong>Últimos {{ articulosList.length | number:'1.0-0' }} de {{ recTotal | number:'1.0-0' }}</strong>
                            </p>
                            <div class="progress"
                                 style="height: 12px; width: 220px;">
                                <div class="progress-bar bg-success"
                                     role="progressbar"
                                     [style.width.%]="(articulosList.length / recTotal) * 100"
                                     [attr.aria-valuenow]="(rows.length / recTotal) * 100"
                                     aria-valuemin="0"
                                     aria-valuemax="100">
                                </div>
                            </div>
                        </div>

                        <!-- Botón a la derecha -->
                        <div class="mt-2 ml-2">
                            <button [disabled]="loading"
                                    (click)="cargaMas()"
                                    type="button"
                                    class="btn btn-rounded btn-outline-success waves-effect waves-light mr-2">
                                <i *ngIf="loading"
                                   class="fa fa-spinner fa-spin me-1"></i>
                                Cargar más
                            </button>
                        </div>
                    </div>
                </div>










            </div>
        </div>
    </div>

</div>